module.exports = __webpack_public_path__ + "img/how-it-works-2.abbaa05f.jpg";